/* src/app/shared/components/bar-loader/bar-loader.component.scss */
/*# sourceMappingURL=bar-loader.component.css.map */
